
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.75 24a3.016 3.016 0 01-2.902-2.25h-.946A3.016 3.016 0 013 24c-1.654 0-3-1.346-3-3s1.346-3 3-3c1.37 0 2.564.947 2.902 2.25h.947A3.016 3.016 0 019 18.099V15.75H.75a.75.75 0 010-1.5H9V2.8c0-.732-.373-1.3-.694-1.3H.75a.75.75 0 010-1.5h7.556C9.516 0 10.5 1.256 10.5 2.8v15.298A3.016 3.016 0 0112.75 21c0 1.654-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zM3 19.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"}}),_c('path',{attrs:{"d":"M2.25 12.75A.75.75 0 011.5 12V3.818a.75.75 0 011.5 0V12a.75.75 0 01-.75.75zM6 12.75a.75.75 0 01-.75-.75V3.818a.75.75 0 011.5 0V12a.75.75 0 01-.75.75zM17.25 24c-1.654 0-3-1.346-3-3s1.346-3 3-3c1.37 0 2.564.947 2.902 2.25h1.598a.75.75 0 00.75-.75v-6h-2.391a2.772 2.772 0 01-2.858-2.668V6.751h-3V18a.75.75 0 01-1.5 0V2.25c0-.401.313-.729.713-.749a7.39 7.39 0 01.363-.009c2.424 0 4.247 1.274 5.422 3.788A5.243 5.243 0 0124 10.5v9a2.252 2.252 0 01-2.25 2.25h-1.598A3.016 3.016 0 0117.25 24zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm1.5-8.7c.028.655.604 1.201 1.285 1.201l.046-.001H22.5v-1.5a3.755 3.755 0 00-3.749-3.75h-.001v4.05zm-1.205-5.55c-.817-1.402-1.881-2.124-3.295-2.241V5.25h3.295z"}})])
          )
        }
      }
    